import React from 'react';

const StatusBadge = ({ status, type = 'default' }) => {
    const getConfig = () => {
      const configs = {
        // Ticket statuses
        ticket: {
          open: { color: 'blue', label: 'Open', icon: '🔵' },
          in_progress: { color: 'yellow', label: 'In Progress', icon: '🟡' },
          awaiting_user: { color: 'orange', label: 'Awaiting User', icon: '🟠' },
          resolved: { color: 'green', label: 'Resolved', icon: '✅' },
          closed: { color: 'gray', label: 'Closed', icon: '⚫' }
        },
        // Dispute statuses from your PHP controller
        dispute: {
          pending: { color: 'yellow', label: 'Pending', icon: '⏳' },
          in_review: { color: 'orange', label: 'In Review', icon: '🔍' },
          resolved: { color: 'green', label: 'Resolved', icon: '✅' },
          closed: { color: 'gray', label: 'Closed', icon: '🔒' }
        },
        // Order statuses
        order: {
          pending: { color: 'yellow', label: 'Pending', icon: '⏳' },
          confirmed: { color: 'blue', label: 'Confirmed', icon: '✅' },
          shipped: { color: 'purple', label: 'Shipped', icon: '🚚' },
          delivered: { color: 'green', label: 'Delivered', icon: '📦' },
          cancelled: { color: 'red', label: 'Cancelled', icon: '❌' },
          refunded: { color: 'gray', label: 'Refunded', icon: '💰' }
        },
        // User statuses
        user: {
          active: { color: 'green', label: 'Active', icon: '✅' },
          suspended: { color: 'red', label: 'Suspended', icon: '❌' },
          pending: { color: 'yellow', label: 'Pending', icon: '⏳' },
          inactive: { color: 'gray', label: 'Inactive', icon: '⚫' }
        },
        // Category status
        category: {
          true: { color: 'green', label: 'Active', icon: '✅' },
          false: { color: 'gray', label: 'Inactive', icon: '⚫' }
        },
        // Default
        default: {
          active: { color: 'green', label: 'Active', icon: '✅' },
          inactive: { color: 'gray', label: 'Inactive', icon: '⚫' },
          pending: { color: 'yellow', label: 'Pending', icon: '⏳' },
          approved: { color: 'green', label: 'Approved', icon: '✅' },
          rejected: { color: 'red', label: 'Rejected', icon: '❌' }
        }
      };
  
      const config = configs[type] || configs.default;
      
      // Handle boolean status for categories
      if (type === 'category' && (status === true || status === false)) {
        return config[status];
      }
      
      return config[status] || { color: 'gray', label: status || 'Unknown', icon: '❓' };
    };
  
    const config = getConfig();
  
    const colorClasses = {
      blue: 'bg-blue-100 text-blue-800 border-blue-200',
      green: 'bg-green-100 text-green-800 border-green-200',
      yellow: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      red: 'bg-red-100 text-red-800 border-red-200',
      orange: 'bg-orange-100 text-orange-800 border-orange-200',
      purple: 'bg-purple-100 text-purple-800 border-purple-200',
      gray: 'bg-gray-100 text-gray-800 border-gray-200'
    };
  
    return (
      <span className={`px-2 py-1 text-xs font-medium rounded-full border inline-flex items-center space-x-1 ${colorClasses[config.color]}`}>
        <span>{config.icon}</span>
        <span>{config.label}</span>
      </span>
    );
  };
  
export default StatusBadge;